import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 瓜田黑料",
    description: "这个地址没有对应的档案。可以回到首页查看风向速览，或前往案例库浏览全部已归档事件。",
    keywords: "瓜田黑料,页面不存在",
    path: location.pathname,
    jsonLd: undefined,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1440px] flex-1 flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="font-heading text-6xl font-bold text-background-300 md:text-8xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这一页没有归档记录
        </h1>
        <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
          地址可能已经调整，或者链接少了一个字符。回到首页看今天的风向，或者直接去案例库翻一翻。
        </p>
        <p className="mt-2 rounded-md bg-background-100 px-3 py-1.5 font-label text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-800 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-4-line text-base" aria-hidden="true" />
            回到首页
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-archive-2-line text-base" aria-hidden="true" />
            浏览案例库
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}